<div class="modal" [class.show]="isOpen" [style.display]="isOpen ? 'block' : 'none'" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{'seller_profile.verify_phone' | translate}}</h5>
                <button type="button" class="btn-close" (click)="onClose()"></button>
            </div>
            <div class="modal-body text-center">
                <p class="mb-4">
                    {{'seller_profile.verification_sent_to' | translate}} <strong>{{phoneNumber}}</strong>
                </p>
                <p class="text-muted small mb-4">
                    {{'seller_profile.keep_popup_open' | translate}}
                </p>
                <div class="alert alert-warning mb-4">
                    <i class="bi bi-exclamation-triangle-fill me-2"></i>
                    <strong>{{'seller_profile.do_not_refresh' | translate}}</strong>
                </div>

                <!-- Error Message -->
                <div *ngIf="errorMessage" class="alert alert-danger mb-3">
                    {{errorMessage}}
                </div>

                <!-- 6 Digit Inputs -->
                <div class="verification-inputs mb-4">
                    <input
                        #inputEl
                        *ngFor="let input of inputs.controls; let i = index"
                        [formControl]="$any(input)"
                        [attr.autocomplete]="i === 0 ? 'one-time-code' : null"
                        type="text"
                        inputmode="numeric"
                        maxlength="1"
                        class="form-control verification-digit"
                        (focus)="handleFocus($event)"
                        (keypress)="handleKeyPress($event, i)"
                        (input)="handleInput()"
                        (keydown)="handleKeyDown($event, i)"
                        (paste)="handlePaste($event, i)">
                </div>

                <!-- Resend Button with Countdown -->
                <div class="mb-3">
                    <button
                        type="button"
                        class="btn btn-link"
                        [disabled]="resendDisabled"
                        (click)="onResend()">
                        <span *ngIf="resendDisabled">
                            {{'seller_profile.resend_in' | translate}} {{formattedCountdown}}
                        </span>
                        <span *ngIf="!resendDisabled">
                            {{'seller_profile.resend_code' | translate}}
                        </span>
                    </button>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="onClose()">
                    {{'common.cancel' | translate}}
                </button>
                <button
                    type="button"
                    class="btn btn-primary"
                    [disabled]="verificationCodeValue.length !== 6"
                    (click)="onSubmit()">
                    {{'seller_profile.verify' | translate}}
                </button>
            </div>
        </div>
    </div>
</div>
<div class="modal-backdrop fade show" *ngIf="isOpen"></div>